import { RouteParam } from "../../../routes";
import { ACTION, MODULE } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import ItemCreateScreen from "../items/item_create/item_create_screen";
import ItemListScreen from "../items/item_list_screen";
import ItemUpdateScreen from "../items/item_create/item_update_screen";
import ItemViewScreen from "../items/item_create/item_view_screen";
import ItemApproveScreen from "../items/item_create/item_approve_screen";
import PrevItemListScreen from "../prev_item_master/item_master_list";
import PrevItemViewScreen from "../prev_item_master/item_master_view";

const items_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_item,
    component: ItemListScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_item + "/create",
    component: ItemCreateScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_item + "/view-item/:id",
    component: ItemViewScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_item + "/approve-reject-item/:id",
    component: ItemApproveScreen,
    module: MODULE.master_item_checker,
    main_module: MODULE.master_data_panel,
    action: [ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_item + "/update/:id",
    component: ItemUpdateScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_item + "/delete/:id",
    component: ItemViewScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.UPDATE],
    operator: "or",
  },

  //prev item master routes
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_item_prev,
    component: PrevItemListScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_item_prev + "/view-item/:id",
    component: PrevItemViewScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.READ],
    operator: "or",
  },
];

export default items_routes;
